export const MAX_ESTIMATION = 1;
export const MAX_LEVEL = 10;

export const DND_TYPES = {
  POWER: 'power',
  HERO: 'hero',
};

export const FINAL_LEVEL_SLUG = 'final-level';
